/**
 * Player-name escaping for chat commands that read a name as one word.
 *
 * `/w` takes its target from the first word after the command, so a name with
 * spaces is written with `&s;` in their place, and `&` becomes `&a;` so the
 * escape stays reversible. Shared by the game's command parser and the chat
 * input's Tab completion, which must produce the same form.
 */

/** Replaces `&` with `&a;` and spaces with `&s;`. */
export function escapePlayerName(playerName: string): string {
  return playerName.replace(/&/g, '&a;').replace(/ /g, '&s;');
}

/** Reverses escapePlayerName. */
export function unescapePlayerName(playerName: string): string {
  return playerName.replace(/&s;/g, ' ').replace(/&a;/g, '&');
}
